var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PCBA",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5,12.818v70.363c0,4.146-3.373,7.519-7.519,7.519H12.618c-4.146,0-7.518-3.373-7.518-7.519V69.554h8V82.7h69.4V13.3 H26.588L13.1,26.789v4.065h-8v-7.378L23.275,5.3h59.707C87.127,5.3,90.5,8.673,90.5,12.818z M5.51,36.404l-0.021,6l21.312,0.071 c0.82,0,1.595-0.327,2.16-0.908l7.472-7.677c2.569,0.912,5.545,0.325,7.571-1.757c2.773-2.85,2.712-7.408-0.138-10.181 c-2.85-2.773-7.408-2.712-10.181,0.138c-2.026,2.081-2.532,5.072-1.551,7.615l-6.584,6.765L5.51,36.404z M59.87,70.384 c2.821,2.802,7.38,2.787,10.182-0.034c2.802-2.821,2.787-7.38-0.034-10.182c-2.06-2.047-5.046-2.583-7.599-1.629l-6.679-6.634 c-0.563-0.558-1.322-0.871-2.114-0.871c-0.001,0-11.559,0.005-11.559,0.005c-0.822,0-1.608,0.338-2.174,0.934l-5.951,6.267H5.5v6 h29.731c0.822,0,1.609-0.338,2.175-0.934l5.952-6.268l9.032-0.003l5.8,5.761C57.253,65.356,57.81,68.337,59.87,70.384z M75.67,43.505c0.003-3.977-3.218-7.202-7.195-7.205c-2.904-0.002-5.402,1.719-6.542,4.195l-24.646-0.018 c-0.819,0-1.601,0.333-2.167,0.922l-5.864,6.107H5.5v6h25.035c0.817,0,1.598-0.333,2.164-0.922l5.863-6.107l23.367,0.017 c1.137,2.477,3.632,4.203,6.536,4.205C72.442,50.703,75.667,47.482,75.67,43.505z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcba);
export default __webpack_public_path__ + "static/media/PCBA.d4389a53c7daa919e666c9049373ff27.svg";
export { ForwardRef as ReactComponent };